import * as React from 'react';
import { connect } from 'react-redux';
import INotesAppState from './interfaces/notesAppState';
import { actionCreators } from './redux/actions';
import NoteGroup from './noteGroup';

const allNotesList: React.SFC<any> = ({ hasNoSearchHits, items, isLoading, selectedNotes, toggleSelectedNote }) => {
	if (isLoading) {
		return <div className="notes-loader">laddar</div>;
	}

	if (items.length === 0) {
		return (
			<div className="bookmarks__list-item bookmarks__list-item--padding-y">
				{hasNoSearchHits ? 'Sökningen gav inga träffar' : 'Du har inga anteckningar eller markeringar'}
			</div>
		);
	}

	return (
		<ol className="notes__list-wrapper" role="presentation">
			{items.map((item, index) => (
				<NoteGroup
					notes={item.notes}
                    groupTitle={item.pageHeading}
                    isArchived={item.isArchived}
					numberOfNotes={item.numberOfNotes}
					selectedNotes={selectedNotes}
					toggleSelectedNote={toggleSelectedNote}
					key={index}
				/>
			))}
		</ol>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		toggleSelectedNote: (id: any) => {
			dispatch(actionCreators.setSelectedNotes(id));
		}
	};
};

const mapStateToProps = (state: INotesAppState) => {
	return {
		hasNoSearchHits: state.hasNoSearchHits,
		items: state.notes,
		isLoading: state.allNotesListIsLoading,
		selectedNotes: state.selectedNotes
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(allNotesList);
